import React from 'react';
import styles from './DeleteConfirmationModal.module.css';

const UserDeleteConfirmationModal = ({ 
  itemName, 
  onClose, 
  onConfirm, 
  loading,
  warningMessage,
  isDeletingSelf = false,
  isDeletingCompanyUser = false
}) => {
  
  const getWarningMessage = () => {
    if (warningMessage) {
      return warningMessage;
    }
    
    if (isDeletingSelf) {
      return "This account will be deleted permanently. You will have to log in with different email and password.";
    }
    
    if (isDeletingCompanyUser) {
      return "This user will be deleted. They will have to login with new email/password.";
    }
    
    return "This action cannot be undone.";
  };

  const getWarningIcon = () => {
    if (isDeletingSelf) {
      return "⚠️";
    }
    if (isDeletingCompanyUser) {
      return "👤";
    }
    return "🗑️";
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h3>
             Confirm Deletion
          </h3>
          <button className={styles.closeBtn} onClick={onClose} disabled={loading}>×</button>
        </div>
        <div className={styles.modalBody}>
          <p>Are you sure you want to delete <strong>{itemName}</strong>?</p>
          <div className={`${styles.warningText} ${isDeletingSelf ? styles.selfDeleteWarning : isDeletingCompanyUser ? styles.companyUserWarning : ''}`}>
            
            <p>{getWarningMessage()}</p>
          </div>
        </div>
        <div className={styles.modalFooter}>
          <button 
            className={`${styles.btn} ${styles.btnSecondary}`} 
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button 
            className={`${styles.btn} ${styles.btnDanger} ${isDeletingSelf ? styles.btnDangerSelf : ''}`} 
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className={styles.spinnerBorder}></span> Deleting...
              </>
            ) : (
              isDeletingSelf ? 'Delete My Account' : 'Delete User'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserDeleteConfirmationModal;
